const state = {
    selectedLeagueDetailsStore: [],
    sportname:null
};
const getters = {
    selectedLeagueDetailsStore: state => state?.selectedLeagueDetailsStore,
    sportname: state => state?.sportname,
};
const actions = {  
    setselectedLeagueDetailsStore({ commit }, filter) {
        commit('setselectedLeagueDetailsStore', filter);
    },
    setsportname({ commit }, filter) {
        commit('setsportname', filter);
    },
};
const mutations = {
    setselectedLeagueDetailsStore(state, selectedLeagueDetailsStore) {
        state.selectedLeagueDetailsStore = selectedLeagueDetailsStore;
    },
    setsportname(state, sportname) {
        state.sportname = sportname;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};